import { Action } from 'redux';
import { Invoice, SendInvoiceToCustomerResponse } from './types';
import { ErrorResponse, ListPayload } from 'core/http/response';

export enum InvoiceActions {
    GET_INVOICE_BY_ID_REQUEST = 'GET_INVOICE_BY_ID_REQUEST',
    GET_INVOICE_BY_ID_SUCCESS = 'GET_INVOICE_BY_ID_SUCCESS',
    GET_INVOICE_BY_ID_ERROR = 'GET_INVOICE_BY_ID_ERROR',
    UPDATE_INVOICE_REQUEST = 'UPDATE_INVOICE_REQUEST',
    UPDATE_INVOICE_SUCCESS = 'UPDATE_INVOICE_SUCCESS',
    UPDATE_INVOICE_ERROR = 'UPDATE_INVOICE_ERROR',
    LIST_INVOICES_REQUEST = 'LIST_INVOICES_REQUEST',
    LIST_INVOICES_SUCCESS = 'LIST_INVOICES_SUCCESS',
    LIST_INVOICES_ERROR = 'LIST_INVOICES_ERROR',
    ARCHIVE_INVOICE_REQUEST = 'ARCHIVE_INVOICE_REQUEST',
    ARCHIVE_INVOICE_SUCCESS = 'ARCHIVE_INVOICE_SUCCESS',
    ARCHIVE_INVOICE_ERROR = 'ARCHIVE_INVOICE_ERROR',
    UNARCHIVE_INVOICE_REQUEST = 'UNARCHIVE_INVOICE_REQUEST',
    UNARCHIVE_INVOICE_SUCCESS = 'UNARCHIVE_INVOICE_SUCCESS',
    UNARCHIVE_INVOICE_ERROR = 'UNARCHIVE_INVOICE_ERROR',
    DUPLICATE_INVOICE_REQUEST = 'DUPLICATE_INVOICE_REQUEST',
    DUPLICATE_INVOICE_SUCCESS = 'DUPLICATE_INVOICE_SUCCESS',
    DUPLICATE_INVOICE_ERROR = 'DUPLICATE_INVOICE_ERROR',
    SEND_TO_CLIENT_REQUEST = 'SEND_TO_CLIENT_REQUEST',
    SEND_TO_CLIENT_SUCCESS = 'SEND_TO_CLIENT_SUCCESS',
    SEND_TO_CLIENT_ERROR = 'SEND_TO_CLIENT_ERROR',
    UPDATE_INVOICE_STATUS_REQUEST = 'UPDATE_INVOICE_STATUS_REQUEST',
    UPDATE_INVOICE_STATUS_SUCCESS = 'UPDATE_INVOICE_STATUS_SUCCESS',
    UPDATE_INVOICE_STATUS_ERROR = 'UPDATE_INVOICE_STATUS_ERROR',
}

export interface GET_INVOICE_BY_ID_REQUEST extends Action {
    type: InvoiceActions.GET_INVOICE_BY_ID_REQUEST;
}
export interface GET_INVOICE_BY_ID_SUCCESS extends Action {
    type: InvoiceActions.GET_INVOICE_BY_ID_SUCCESS;
    payload: Invoice;
}
export interface GET_INVOICE_BY_ID_ERROR extends Action {
    type: InvoiceActions.GET_INVOICE_BY_ID_ERROR;
    error: ErrorResponse;
}

export interface UPDATE_INVOICE_REQUEST extends Action {
    type: InvoiceActions.UPDATE_INVOICE_REQUEST;
}
export interface UPDATE_INVOICE_SUCCESS extends Action {
    type: InvoiceActions.UPDATE_INVOICE_SUCCESS;
    payload: Invoice;
}
export interface UPDATE_INVOICE_ERROR extends Action {
    type: InvoiceActions.UPDATE_INVOICE_ERROR;
    error: ErrorResponse;
}

export interface LIST_INVOICES_REQUEST extends Action {
    type: InvoiceActions.LIST_INVOICES_REQUEST;
}
export interface LIST_INVOICES_SUCCESS extends Action {
    type: InvoiceActions.LIST_INVOICES_SUCCESS;
    payload: ListPayload<Invoice>;
}
export interface LIST_INVOICES_ERROR extends Action {
    type: InvoiceActions.LIST_INVOICES_ERROR;
    error: ErrorResponse;
}

export interface ARCHIVE_INVOICE_REQUEST extends Action {
    type: InvoiceActions.ARCHIVE_INVOICE_REQUEST;
}
export interface ARCHIVE_INVOICE_SUCCESS extends Action {
    type: InvoiceActions.ARCHIVE_INVOICE_SUCCESS;
    payload: Invoice;
}
export interface ARCHIVE_INVOICE_ERROR extends Action {
    type: InvoiceActions.ARCHIVE_INVOICE_ERROR;
    error: ErrorResponse;
}

export interface UNARCHIVE_INVOICE_REQUEST extends Action {
    type: InvoiceActions.UNARCHIVE_INVOICE_REQUEST;
}
export interface UNARCHIVE_INVOICE_SUCCESS extends Action {
    type: InvoiceActions.UNARCHIVE_INVOICE_SUCCESS;
    payload: Invoice;
}
export interface UNARCHIVE_INVOICE_ERROR extends Action {
    type: InvoiceActions.UNARCHIVE_INVOICE_ERROR;
    error: ErrorResponse;
}

export interface DUPLICATE_INVOICE_REQUEST extends Action {
    type: InvoiceActions.DUPLICATE_INVOICE_REQUEST;
}
export interface DUPLICATE_INVOICE_SUCCESS extends Action {
    type: InvoiceActions.DUPLICATE_INVOICE_SUCCESS;
    payload: Invoice;
}
export interface DUPLICATE_INVOICE_ERROR extends Action {
    type: InvoiceActions.DUPLICATE_INVOICE_ERROR;
    error: ErrorResponse;
}

export interface SEND_TO_CLIENT_REQUEST extends Action {
    type: InvoiceActions.SEND_TO_CLIENT_REQUEST;
}
export interface SEND_TO_CLIENT_SUCCESS extends Action {
    type: InvoiceActions.SEND_TO_CLIENT_SUCCESS;
    invoiceId: string;
    payload: SendInvoiceToCustomerResponse;
}
export interface SEND_TO_CLIENT_ERROR extends Action {
    type: InvoiceActions.SEND_TO_CLIENT_ERROR;
    error: ErrorResponse;
}

export interface UPDATE_INVOICE_STATUS_REQUEST extends Action {
    type: InvoiceActions.UPDATE_INVOICE_STATUS_REQUEST;
}
export interface UPDATE_INVOICE_STATUS_SUCCESS extends Action {
    type: InvoiceActions.UPDATE_INVOICE_STATUS_SUCCESS;
    payload: Invoice;
}
export interface UPDATE_INVOICE_STATUS_ERROR extends Action {
    type: InvoiceActions.UPDATE_INVOICE_STATUS_ERROR;
    error: ErrorResponse;
}

export type InvoiceActionTypes =
    | GET_INVOICE_BY_ID_REQUEST
    | GET_INVOICE_BY_ID_SUCCESS
    | GET_INVOICE_BY_ID_ERROR
    | UPDATE_INVOICE_REQUEST
    | UPDATE_INVOICE_SUCCESS
    | UPDATE_INVOICE_ERROR
    | LIST_INVOICES_REQUEST
    | LIST_INVOICES_SUCCESS
    | LIST_INVOICES_ERROR
    | ARCHIVE_INVOICE_REQUEST
    | ARCHIVE_INVOICE_SUCCESS
    | ARCHIVE_INVOICE_ERROR
    | UNARCHIVE_INVOICE_REQUEST
    | UNARCHIVE_INVOICE_SUCCESS
    | UNARCHIVE_INVOICE_ERROR
    | DUPLICATE_INVOICE_REQUEST
    | DUPLICATE_INVOICE_SUCCESS
    | DUPLICATE_INVOICE_ERROR
    | SEND_TO_CLIENT_REQUEST
    | SEND_TO_CLIENT_SUCCESS
    | SEND_TO_CLIENT_ERROR
    | UPDATE_INVOICE_STATUS_REQUEST
    | UPDATE_INVOICE_STATUS_SUCCESS
    | UPDATE_INVOICE_STATUS_ERROR;
